module.exports = __webpack_public_path__ + "static/img/2018120503.780a888.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/2018120503.jpg
// module id = ghKJ
// module chunks = 1